export default {
  user: 'user',
  institution: 'institution'
}
